/**
 * Angular imports.
 */
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

/**
 * Constant imports.
 */
import { NUMBERS, STORY_HEADER_ACTIONS } from 'src/app/constants/app.constants';

/**
 * Service imports.
 */
import { NewLanguageService } from 'src/app/dataservices/new-language/new-language.service';

/**
 * Header for the basic profile which include user, pharma, channel etc.
 */
@Component({
  selector: 'app-profile-basic-header',
  templateUrl: './profile-basic-header.component.html',
  styleUrls: ['./profile-basic-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProfileBasicHeaderComponent {

  /**
   * Header information.
   * Show/Hide mute icon.
   * Is video muted status.
   * Created on time.
   */
  @Input() profileImage: any;
  @Input() isMe: any;
  @Input() fullName: any;
  @Input() channelId: number
  @Input() readonly showVolume: boolean;
  @Input() isMuted: boolean;
  @Input() speciality: string;
  @Input() readonly createdOn: any;
  @Input() readonly headerDropdownList: { id: number, text: string };
  @Input() loadingState: boolean
  @Input() youText: string;

  /**
   * Emit the API request.
   * Emit the dropdown actions.
   * Toggle progress bar status.
   * Emit mute video status.
   */
  @Output() emitRequest: EventEmitter<void> = new EventEmitter();
  @Output() emitAction: EventEmitter<number> = new EventEmitter();
  @Output() emitToggleProgressCounter: EventEmitter<boolean> = new EventEmitter();
  @Output() emitToggleMuteStatus: EventEmitter<boolean> = new EventEmitter();
  @Output() emitClose: EventEmitter<void> = new EventEmitter();

  @Output() headerClicked: EventEmitter<void> = new EventEmitter();

  /**
   * Header action constant.
   * Numbers constant.
   */
  readonly headerActions = STORY_HEADER_ACTIONS;
  readonly numbers = NUMBERS;
  public isDropdown = false;

  /**
   * Emit the API request.
   */
  sendRequest(): void {
    this.emitRequest.emit();
  }

  /**
   * Emit the dropdown actions.
   */
  doAction(action: number): void {
    this.emitAction.emit(action);
  }

  /**
   * Toggle progress bar status.
   */
  toggleProgressCounter(status: boolean): void {
    this.isDropdown = status;
    this.emitToggleProgressCounter.emit(status);
  }
  /**
   * close story
   */
  closeStories(): void {
    this.emitClose.emit();
  }
  redirectToProfile(): void {
    this.headerClicked.emit();
  }
  /**
   * Emit mute video status.
   */
  setMute(): void {
    this.isMuted = !this.isMuted;
    this.emitToggleMuteStatus.emit(this.isMuted);
  }
}
